// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  background: #eceeef linear-gradient(rgba(0, 0, 0, 0), #fff);
  width: 100%;
  min-width: 1200px;
  height: 100%;
  min-height: 600px;
  margin: 0;
  padding: 0;
  font-family: PingFang SC, Noto Sans SC, sans-serif;
}

body {
  line-height: 1.5;
}

#root {
  width: 100%;
  height: 100%;
}

html.agent-share-viewport, body.agent-share-viewport {
  width: 100%;
  min-width: 0;
  height: 100vh;
  height: var(--agent-share-viewport-height, 100dvh);
  min-height: 0;
  overflow: hidden;
}

body.agent-share-viewport {
  overscroll-behavior: none;
}

body.agent-share-viewport #root {
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
}

html.harness-share-viewport, body.harness-share-viewport {
  width: 100%;
  min-width: 0;
  height: 100vh;
  height: var(--harness-share-viewport-height, 100dvh);
  min-height: 0;
  overflow: hidden;
}

body.harness-share-viewport {
  overscroll-behavior: none;
}

body.harness-share-viewport #root {
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
}

p {
  margin: 0;
}

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: PingFang SC, Noto Sans SC, sans-serif;
}

a:focus, input:focus, p:focus, li:focus, div:focus, svg:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

a:focus-visible {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

input:focus-visible {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

p:focus-visible {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

li:focus-visible {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

div:focus-visible {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0% / 0);
  outline: none;
}

.operation-admin-base-header {
  background-color: #fff;
  border-bottom: 1px solid rgba(46, 50, 56, .05);
  justify-content: space-between;
  align-items: flex-end;
  height: 56px;
  line-height: 56px;
  display: flex;
}

.operation-admin-base-header .semi-tabs-content {
  display: none;
}

.operation-admin-base-header-title {
  color: var(--light-color-grey-grey-9, #1c1f23);
  align-items: center;
  margin: 12px 24px;
  font-size: 18px;
  line-height: 24px;
  display: flex;
}

.operation-admin-base-header-title * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.operation-admin-base-header-title .universe-icon {
  margin-right: 6px;
}

.operation-admin-base-header-user-avatar {
  width: 24px;
  height: 24px;
}

.operation-admin-base-header-avatar-method-block {
  justify-content: center;
  width: 100%;
  padding: 8px;
  display: flex;
}

.operation-admin-base-header-avatar-sign-out {
  text-align: center;
}

.operation-admin-base-aside, .operation-admin-base-aside .ud__layout__sider-trigger {
  border-right: 1px solid #e5e7eb;
}

.operation-admin-base-app {
  height: 100%;
}

.operation-admin-base-module-content {
  flex-direction: column;
  align-items: flex-start;
  display: flex;
  overflow-y: auto;
}

.operation-admin-base-module-content[app-name="playground_prompt"], .operation-admin-base-module-content[app-name="build_bot"], .operation-admin-base-module-content[app-name="discover"] {
  background-color: #fff;
}

.operation-admin-base-404 {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.no-permission {
  border: 20px solid #f2f3f5;
  height: calc(100vh - 64px);
}

.error-wrapper {
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.operation-admin-no-permission {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.operation-admin-base-main-content {
  overflow: hidden;
}

.operation-admin-base-header-name {
  padding: 8px 8px 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
}

.bp5-overflow-list {
  flex-wrap: nowrap;
  min-width: 0;
  display: flex;
}

.bp5-overflow-list-spacer {
  flex-shrink: 1;
  width: 1px;
}

.styled-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(31, 35, 41, .3);
  background-clip: padding-box;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 9999px;
  transition: background .2s cubic-bezier(.34, .69, .1, 1);
}

.styled-scrollbar::-webkit-scrollbar {
  background-color: rgba(0, 0, 0, 0);
  width: 11px;
  height: 11px;
  display: inline-block;
}

.styled-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(31, 35, 41, .6);
}

.styled-scrollbar::-webkit-scrollbar:hover {
  width: 11px;
  height: 11px;
}

.styled-scrollbar::-webkit-scrollbar-button {
  display: none;
}

.styled-scrollbar::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

.styled-scrollbar::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
